import React from 'react';

// eslint-disable-next-line react/prop-types
export const SelectCheckBoxIcon = () => {
  return (
    <>
      <path
        fill="none"
        strokeWidth="3"
        strokeLinecap="round"
        strokeLinejoin="round"
        stroke="rgb(23.529412%,54.901961%,94.509804%)"
        strokeOpacity="1"
        strokeMiterlimit="4"
        d="M 16.069336 20.895996 L 20.895996 25.715332 L 36.965332 9.645996 "
        transform="matrix(0.533333,0,0,0.533333,0,0)"
      />
      <path
        fill="none"
        strokeWidth="3"
        strokeLinecap="round"
        strokeLinejoin="round"
        stroke="rgb(23.529412%, 54.901961%, 94.509804%)"
        strokeOpacity="1"
        strokeMiterlimit="4"
        d="M 35.354004 22.5 L 35.354004 33.75 C 35.354004 34.599609 35.01709 35.419922 34.416504 36.020508 C 33.808594 36.628418 32.995605 36.965332 32.138672 36.965332 L 9.638672 36.965332 C 8.789062 36.965332 7.96875 36.628418 7.368164 36.020508 C 6.767578 35.419922 6.430664 34.599609 6.430664 33.75 L 6.430664 11.25 C 6.430664 10.400391 6.767578 9.580078 7.368164 8.979492 C 7.96875 8.371582 8.789062 8.034668 9.638672 8.034668 L 27.319336 8.034668 "
        transform="matrix(0.533333,0,0,0.533333,0,0)"
      />
    </>
  );
};



// WEBPACK FOOTER //
// ./src/vp-ui/svgs/SelectCheckBoxIcon.jsx